<template>
  <div class="page">
    <div class="app-container">
      <BaseTable
        ref="baseTable"
        url="/admin/dict/systemConfig"
        :tableData.sync="tableData"
        :columns="columns"
		:searchParams="searchData"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
        </template>
      </BaseTable>
      <BaseDialog
        :visible.sync="dialogVisible"
        title="修改平台参数"
        @confirm="handleDialogConfirm"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :formOptions="formOption"
          itemWidth="100%"
        ></BaseForm>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import { columns,formOption } from "./columns";

export default {
  name: "Config",
  comments: {},
  data() {
    return {
	  tableData: [],
	  formData: {
		  name: '',
		  value: '',
		  describe: ''
	  },
	  searchData: {},
	  dialogVisible: false
    };
  },
  computed: {
    columns,
	formOption
  },
  created() {},
  methods: {
    edit(row) {
      this.formData = { ...row };
      this.dialogVisible = true;
    },
	// 提交
	handleDialogConfirm(cb) {
		// 用来结束loading
		this.$refs.baseForm.onSubmit(async (validate) => {
		  if (validate) {
		    const confirm = await this.$confirm('是否确认提交？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning',
		    }).catch(() => {});
		    if (confirm) {
				const data = this.formData;
		      await this.$api.post('/admin/dict/systemConfigSave', { 
				  'id': data.id,
				  'value': data.value,
			  }, '系统配置提交');
		      this.dialogVisible = false;
		      this.handleSearch();
		    }
		    cb(false);
		  } else {
		    cb();
		  }
		});
	},
	// 点击搜索
	handleSearch() {
	  // console.log(this.searchData);
	  this.$refs.baseTable.searchData();
	},
  },
};
</script>
